import { getNavKeyForHref } from '../config/navigationCatalog';

export type NavItemLike = {
  href: string;
  subItems?: NavItemLike[];
  navKey?: string;
};

export function expandPermissionKeys(keys: string[]): Set<string> {
  return new Set(keys);
}

export function isNavKeyGranted(navKey: string, permissions: Set<string>): boolean {
  if (permissions.has('*')) {
    return true;
  }
  return permissions.has(navKey);
}

export function filterNavItems<T extends NavItemLike>(
  items: T[],
  canAccess: (navKey: string) => boolean,
): T[] {
  return items
    .map(item => {
      const navKey = item.navKey ?? getNavKeyForHref(item.href);
      if (item.subItems && item.subItems.length > 0) {
        const subItems = filterNavItems(item.subItems, canAccess);
        if (subItems.length === 0) {
          return null;
        }
        const parentKey = navKey ?? getNavKeyForHref(item.href);
        if (!parentKey || !canAccess(parentKey)) {
          return null;
        }
        return { ...item, subItems } as T;
      }
      if (!navKey) {
        return null;
      }
      if (!canAccess(navKey)) {
        return null;
      }
      return item;
    })
    .filter((item): item is T => item !== null);
}
